/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NotificationMessage } from '../../models/notification-message';

export interface ApiTransactionDelete$Params {
  guid?: string;
  'api-version'?: string;
}

export function apiTransactionDelete(http: HttpClient, rootUrl: string, params?: ApiTransactionDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
  const rb = new RequestBuilder(rootUrl, apiTransactionDelete.PATH, 'delete');
  if (params) {
    rb.query('guid', params.guid, {});
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NotificationMessage>;
    })
  );
}

apiTransactionDelete.PATH = '/api/transaction';
